import { createIcon } from '@chakra-ui/icons';

export const HeartFilled = createIcon({
  displayName: 'HeartFilled',
  viewBox: '0 0 24 23',
  d: 'M12 22.02L10.26 20.436C4.08 14.832 0 11.124 0 6.6C0 2.892 2.904 0 6.6 0C8.688 0 10.692 0.972 12 2.496C13.308 0.972 15.312 0 17.4 0C21.096 0 24 2.892 24 6.6C24 11.124 19.92 14.832 13.74 20.436L12 22.02Z',
});
